import repositories from '..';

const resource = '/integration/webhooks';

export default {
  getInitData: (data: any) => repositories.get(`${resource}/data/init?moduleId=${data}`),
  resendWebHook: (data: any) => repositories.put(`${resource}/histories/${data.id}`),
};
